const structByColor = (color, text) => {
  return (
    <div className="flex w-fit items-center justify-center flex-row gap-x-2">
      <span className="text-dark-green text-sm">{text}</span>
      <span
        className={`border-[1px] rounded-full h-[20px] w-[20px]`}
        style={{ backgroundColor: `#${color}` }}
      />
    </div>
  );
};

export const isOutOfRange = (prop, value) => {
  switch (prop) {
    case "temperature":
      return value < 18.0 || value > 28.0;
    case "humidity":
      return value < 60.0 || value > 80.0;
    case "light":
      return value > 20000.0 || value < 1000.0;
    case "ph":
      return value < 5.8 || value > 6.5;
    default:
      return false;
  }
};

export const colorOptions = [
  { text: structByColor("FFFFFF", "Blanco"), value: "FFFFFF" },
  { text: structByColor("E6E6FA", "Lila"), value: "E6E6FA" },
  { text: structByColor("FFC0CB", "Rosa"), value: "FFC0CB" },
  { text: structByColor("FF00FF", "Fucsia"), value: "FF00FF" },
  { text: structByColor("FFFF00", "Amarillo"), value: "FFFF00" },
  { text: structByColor("FFA500", "Naranja"), value: "FFA500" },
  { text: structByColor("800080", "Púrpura"), value: "800080" },
  { text: structByColor("4B0082", "Morado"), value: "4B0082" },
  { text: structByColor("FF0000", "Rojo"), value: "FF0000" },
  { text: structByColor("008000", "Verde"), value: "008000" },
  { text: structByColor("0000FF", "Azul"), value: "0000FF" },
  { text: structByColor("8B4513", "Marrón"), value: "8B4513" },
  { text: structByColor("000000", "Negro"), value: "000000" },
];
